// extracted by mini-css-extract-plugin
export var adlist = "sectionAdList-module--adlist--28652";
export var buttons = "sectionAdList-module--buttons--6e268";
export var card = "sectionAdList-module--card--7a2cc";
export var firstText = "sectionAdList-module--firstText--ad138";
export var logo = "sectionAdList-module--logo--4a344";
export var logoAndRatings = "sectionAdList-module--logoAndRatings--a2434";
export var logoAndText = "sectionAdList-module--logoAndText--46820";
export var number = "sectionAdList-module--number--ce334";
export var rating = "sectionAdList-module--rating--62573";
export var rating1 = "sectionAdList-module--rating1--51773";
export var rating15 = "sectionAdList-module--rating15--58388";
export var rating2 = "sectionAdList-module--rating2--28363";
export var rating25 = "sectionAdList-module--rating25--79182";
export var rating3 = "sectionAdList-module--rating3--97fdf";
export var rating35 = "sectionAdList-module--rating35--7e4f1";
export var rating4 = "sectionAdList-module--rating4--3c81a";
export var rating45 = "sectionAdList-module--rating45--9265a";
export var richtext = "sectionAdList-module--richtext--f7766";
export var secondText = "sectionAdList-module--secondText--00fad";
export var section = "sectionAdList-module--section--f50a3";
export var showMore = "sectionAdList-module--showMore--3e42b";
export var starRating = "sectionAdList-module--starRating--e3e70";